import type { ComponentProps } from 'react';
import { Option, Predicate, Schema } from 'effect';

import Image from '@vs-shop/image-link/Image';
import { ImageMissingPlaceholder } from '@vs-shop/ui/imageMissingPlaceholder';

const dimension = Schema.decodeUnknownOption(
  Schema.Union([Schema.Finite, Schema.FiniteFromString])
);

/** CMS images use the shared fallback adapter without a synthetic aspect ratio. */
export const MarkdownImage = ({
  src,
  alt,
  width,
  height,
  title,
  className,
  style,
  loading,
}: ComponentProps<'img'>) =>
  Option.match(Option.filter(Option.fromNullishOr(src), Predicate.isString), {
    onNone: () => null,
    onSome: (source) => (
      <Image
        src={source}
        alt={Option.getOrElse(Option.fromNullishOr(alt), () => '')}
        {...Option.match(dimension(width), {
          onNone: () => ({}),
          onSome: (decodedWidth) => ({ width: decodedWidth }),
        })}
        {...Option.match(dimension(height), {
          onNone: () => ({}),
          onSome: (decodedHeight) => ({ height: decodedHeight }),
        })}
        {...(Predicate.isString(title) && { title })}
        {...Option.match(Option.fromNullishOr(className), {
          onNone: () => ({}),
          onSome: (imageClassName) => ({ className: imageClassName }),
        })}
        {...Option.match(Option.fromNullishOr(style), {
          onNone: () => ({}),
          onSome: (imageStyle) => ({ style: imageStyle }),
        })}
        {...Option.match(Option.fromNullishOr(loading), {
          onNone: () => ({}),
          onSome: (imageLoading) => ({ loading: imageLoading }),
        })}
        fallback={<ImageMissingPlaceholder className="size-6" />}
        unoptimized
      />
    ),
  });
